module.exports = __webpack_public_path__ + "assets/thumbs_up.68fd94e361dad16e4deb7cd6c2750704.png";